import React from "react";
import { useRetrieveDiscussion } from "@planzone/view-models";
import { Props } from "./types";
import { CommentIcon } from "./commentIcon";
import styles from "./styles.scss";

function CommentsCount({ subject, type, commentsNbr }: Props) {
  const {
    discussion,
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    retrieveDiscussion,
  } = useRetrieveDiscussion(subject);
  const count = commentsNbr || discussion.comments.length;

  React.useEffect(() => {
    typeof commentsNbr === "undefined" &&
      !isRequestPending &&
      !isRequestFailure &&
      !isRequestSuccess &&
      retrieveDiscussion({ subject, type });
  }, [subject, type]);

  return isRequestPending ? (
    <div className={styles.commentsCount}>
      <p className={styles.count} />
      <div className={styles.icon} />
    </div>
  ) : count === 0 ? (
    <div className={styles.commentsCount}>
      <p className={styles.count} />
      <div className={styles.icon} />
    </div>
  ) : (
    <div className={styles.commentsCount}>
      <p className={styles.count}>{count}</p>
      <CommentIcon className={styles.icon} />
    </div>
  );
}

export { CommentsCount };
